<app-template-text-list
  [templateTexts]="templateTexts$ | async"
  (onTemplateClick)="templateClicked($event)"
>
</app-template-text-list>
